


export default {
    // 公共
    hello:"Hello~",
    welcome: "歡迎來到 Plus18 Games 客服中心",
    connecting: "您的專屬客服正在接入中...",
    waitting: "請稍等片刻",
    email:"客服郵箱",
    kefu:"客服",
    kefu_center:"客服中心",

}